import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Autocomplete,
  FormControl, Grid, InputLabel,
  ListItemAvatar,
  ListItemText,
  MenuItem, Select, SelectChangeEvent,
  TextField,
  Typography
} from "@mui/material";
import { ChangeEventHandler } from "react";
import { GroupMember } from "../../models/GroupMember";
import { UserHelper } from "../../models/UserHelper";
import { UserInfo } from "../../models/UserInfo";
import useStyles from "../../styles/useStyles";
import UserAvatar from "../User/UserAvatar";

export interface MembershipFilters {
  nameLike?: string,
  sortB?: string,
}

export default function ListMembershipsFilters({ nameLike, emailLike, sortBy, handleChange, handleChangeSortBy }: {
  nameLike: string | undefined,
  emailLike: string | undefined,
  sortBy: string | undefined,
  handleChange: ChangeEventHandler
  handleChangeSortBy: (event: SelectChangeEvent<string>) => void
}) {
  const styles = useStyles()

  return (
    <>
      <Accordion className={styles.filterMenu} disableGutters defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.filterButton}>
          <Typography variant="h6" sx={{ margin: 0 }}>Filters</Typography>
        </AccordionSummary>
        <Grid container flexDirection='row' justifyContent='space-between'>
          <Grid item xs={12} md={7} mb={2}>
            <FormControl fullWidth style={{ paddingRight: '1rem' }}>
              <TextField
                id="nameLike"
                label="Filter by name"
                variant="outlined"
                value={nameLike ?? ""}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={5} mb={2}>
            <FormControl fullWidth>
              <InputLabel>Sort</InputLabel>
              <Select
                id="sort"
                label="Sort"
                onChange={handleChangeSortBy}
                value={sortBy ?? ""}
              >
                <MenuItem value="nameasc">Name, alphabetical</MenuItem>
                <MenuItem value="namedesc">Name, reverse</MenuItem>
                <MenuItem value="emailasc">Email, alphabetical</MenuItem>
                <MenuItem value="emaildesc">Email, reverse</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={7} mb={2}>
            <FormControl fullWidth style={{ paddingRight: '1rem' }}>
              <TextField
                id="emailLike"
                label="Filter by email"
                variant="outlined"
                value={emailLike ?? ""}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Accordion>

    </>
  )
}


export function AutocompleteMemberships({ memberships, value, handleInputChange, handleChange, label, styleOverride }: {
  value: UserInfo | null
  memberships: GroupMember[],
  handleInputChange: (event: React.SyntheticEvent, newInputValue: string) => void,
  handleChange: (_event: React.SyntheticEvent<Element, Event>, value: UserInfo | null) => void,
  label?: string,
  styleOverride?: {
    width?: string,
    marginRight?: string,
  }
}) {

  return (
    <Autocomplete
      id='memberships'
      value={value}
      onChange={handleChange}
      style={{
        width: styleOverride?.width ? styleOverride.width : '100%',
        marginRight: styleOverride?.marginRight ? styleOverride.marginRight : '0rem'
      }}
      onInputChange={handleInputChange}
      options={memberships.map(mem => mem.user)}
      renderOption={(props, option) => {
        const filteredGM = memberships.filter(m => m.userId === option.id)
        const gm = filteredGM[0]
        const uh = new UserHelper(gm.user)
        return <li key={gm.id} {...props} >
          <ListItemAvatar>
            <UserAvatar userInfo={gm.user} />
          </ListItemAvatar>
          <ListItemText
            primary={uh.displayName()}
            secondary={gm.user.email}
            sx={{ m: 0 }}
          />
        </li>
      }}
      filterOptions={(x) => x}
      renderInput={(params) => <TextField {...params}
        id="nameLike"
        label={label ?? "Select a team member"}
        variant="outlined"
      />}
      getOptionLabel={(option: UserInfo) => {
        if (!option) return ""
        const uh = new UserHelper(option)
        return uh.displayName()
      }}
      noOptionsText="Type a name to search"
    />
  )
}
